import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import moment from "moment";
import { hasRole, isAdminNotConsultant, isConsultantOrHolding, isIndividual, isProfessional, isWholesaler } from "@/js/http/auth.js";
export default {
  name: "ScheduledMaintenanceAlert",
  data: function data() {
    return {
      currentTime: moment.utc(),
      timer: null,
      hidden: false
    };
  },
  computed: {
    isMaintenanceMode: function isMaintenanceMode() {
      return this.$maintenanceMode.isActive;
    },
    maintenanceStartTime: function maintenanceStartTime() {
      return this.$maintenanceMode.startTime;
    },
    maintenanceExpirationTime: function maintenanceExpirationTime() {
      return this.$maintenanceMode.expirationTime;
    },
    upcomingMaintenance: function upcomingMaintenance() {
      var _upcoming$target_grou;
      var upcoming = this.$maintenanceMode.getUpcomingMaintenance();
      if (!upcoming) return null;
      if (this.hasDeveloperToolsRole) return upcoming;
      var userGroup = this.getUserGroupValue();
      if (!userGroup) return null;
      var matchingGroup = (_upcoming$target_grou = upcoming.target_groups) === null || _upcoming$target_grou === void 0 ? void 0 : _upcoming$target_grou.find(function (g) {
        return g.user_group_value === userGroup;
      });
      if (!matchingGroup) {
        return null;
      }
      return upcoming;
    },
    timeUntilMaintenance: function timeUntilMaintenance() {
      if (!this.upcomingMaintenance) return 0;
      var start = moment.utc(this.upcomingMaintenance.start_time);
      var currentTime = moment.utc(this.currentTime);
      var diffInMinutes = start.diff(currentTime, "minutes");
      return new Date().formatMinutesToDaysHoursMinutes(diffInMinutes, true);
    },
    isTimeUnitilMaintenancePositive: function isTimeUnitilMaintenancePositive() {
      var _timeUntil$match;
      var timeUntil = this.timeUntilMaintenance;
      return parseInt(timeUntil === null || timeUntil === void 0 || (_timeUntil$match = timeUntil.match(/\d+/)) === null || _timeUntil$match === void 0 ? void 0 : _timeUntil$match[0]) > 0;
    },
    getTimeUntilMaintenanceNumber: function getTimeUntilMaintenanceNumber() {
      var _timeUntil$match2;
      var timeUntil = this.timeUntilMaintenance;
      return parseInt(timeUntil === null || timeUntil === void 0 || (_timeUntil$match2 = timeUntil.match(/\d+/)) === null || _timeUntil$match2 === void 0 ? void 0 : _timeUntil$match2[0]);
    },
    timeUntilEnd: function timeUntilEnd() {
      if (!this.upcomingMaintenance) return 0;
      var end = moment.utc(this.upcomingMaintenance.end_time);
      var start = moment.utc(this.upcomingMaintenance.start_time);
      return new Date().formatMinutesToDaysHoursMinutes(end.diff(start, "minutes"), false);
    },
    hasDeveloperToolsRole: function hasDeveloperToolsRole() {
      return hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS);
    },
    canWorkDuringMaintenance: function canWorkDuringMaintenance() {
      if (this.hasDeveloperToolsRole) return false;
      var active = this.$maintenanceMode.scheduledMaintenanceAssociated;
      var group = this.getUserGroupValue();
      if (!(active !== null && active !== void 0 && active.target_groups) || !group) return false;
      var match = active.target_groups.find(function (g) {
        return g.user_group_value === group;
      });
      return (match === null || match === void 0 ? void 0 : match.can_work) == 1 ? true : false;
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return moment(date).format("LLL");
    },
    updateCurrentTime: function updateCurrentTime() {
      this.currentTime = moment.utc();
    },
    hideComponent: function hideComponent() {
      this.hidden = true;
    },
    resetDisplayIfNeeded: function resetDisplayIfNeeded() {
      this.hidden = false;
    },
    getUserGroupValue: function getUserGroupValue() {
      if (isAdminNotConsultant()) return "adminNotConsultant";
      if (isConsultantOrHolding()) return "consultantOrHolding";
      if (isIndividual()) return "individual";
      if (isProfessional()) return "professional";
      if (isWholesaler()) return "wholesaler";
      return null;
    },
    customGroupDescription: function customGroupDescription() {
      var _result;
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.hasDeveloperToolsRole) return null;
      var result = null;
      if (active) {
        result = this.$maintenanceMode.scheduledMaintenanceAssociated;
      } else {
        result = this.upcomingMaintenance;
      }
      var group = this.getUserGroupValue();
      if (!((_result = result) !== null && _result !== void 0 && _result.target_groups) || !group) return null;
      var match = result.target_groups.find(function (g) {
        return g.user_group_value === group;
      });
      return (match === null || match === void 0 ? void 0 : match.custom_description) || null;
    }
  },
  watch: {
    currentTime: {
      immediate: true,
      handler: function handler() {
        var _this = this;
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          _this.updateCurrentTime();
          _this.$maintenanceMode.fetchScheduledMaintenance();
        }, 30000);
      }
    },
    $route: function $route() {
      this.resetDisplayIfNeeded();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};